
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/robotic-process-automation-services",
      function () {
        return require("private-next-pages/robotic-process-automation-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/robotic-process-automation-services"])
      });
    }
  